// @flow
import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import { hot } from 'react-hot-loader/root'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import App from './App'
import CalculatorS from './CalculatorS'
import Calculator from './Calculator'
import Cover from 'components/cover'
import Profile from 'components/profile'
import { Waypoint } from 'react-waypoint'

// TODO Set the correct article ID here
const ARTICLE_ID = '30103176'
let width = window.innerWidth

function AppComponent() {
  return (
    <div className='index'>
      <ThemeSwitch />
      <Masthead inverted articleId={ARTICLE_ID} additionalShares={504} />
      <Cover
        title='Zahlen die Reichen genug Steuern?'
        subtitle='Erstmals zeigen Berechnungen der Universität Luzern, welche Einkommensklassen in der Schweiz wie viel in die Steuertöpfe einzahlen. Entscheiden Sie: Wer könnte mehr zahlen? '
      />
      <div className='ui vertical fitted segment white background'>
        <div className='ui text container'>
          <p className='ta author' style={{ paddingTop: '2em' }}>
            Von Simone Luchetta, Sven Cornehls und Edgar Schuler
          </p>

          {/* <ul>
            <li>
              Die Schweizer Steuerpflichtigen zahlen jährlich 52,1 Milliarden
              Franken Einkommenssteuern an Bund, Kantone und Gemeinden.
            </li>
            <li>
              Das reichste Prozent, mit einem Einkommen von 4,3 Millionen oder
              mehr, zahlt fast ein Viertel aller Einkommenssteuern.
            </li>
            <li>
              Die Steuerzahler in der unteren Einkommenshälfte trag gut einen
              Zehntel bei.
            </li>
          </ul> */}
          <p>
            Die Schweizer Steuerpflichtigen zahlen jährlich{' '}
            <b>52,1 Milliarden Franken</b> Einkommenssteuern an Bund, Kantone
            und Gemeinden.{' '}
            <b>Folgende Aufschlüsselung zeigt, wer wie viel dazu beiträgt:</b>
          </p>
        </div>
      </div>
      <App />
      <Waypoint
        onEnter={event => {
          if (
            event.previousPosition === Waypoint.below &&
            event.currentPosition === Waypoint.inside
          ) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              event: 'Interactions',
              eventAction: 'vertical-scroll',
              eventLabel: '50ContentRead'
            })
          }
        }}
      />

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <p>
            Die Verteilung der Steuerlast für das Jahr 2015 haben Christian Frey
            und Christoph Schaltegger von der Universität Luzern berechnet. Es
            ist die erste Auswertung dieser Art, die nicht nur die Verteilung
            der Steuerlast bei den Bundessteuern aufzeigt, sondern für
            Gemeinden, Kantone und den Bund. Die Gemeinden ziehen rund 15
            Milliarden Franken Steuern ein, die Kantone 25 Milliarden und der
            Bund 12 Milliarden.
          </p>

          <p />
          <h3 className='ui small infographic header'>
            Bundessteuer am progressivsten
          </h3>
          <p>
            Die Untersuchung von Frey und Schaltegger ist politisch relevant,
            weil sich ein weitaus differenzierteres Bild der Steuerbelastung
            ergibt. Bei der Bundessteuer, die lediglich rund ein Fünftel aller
            Einkommenssteuern ausmacht, zahlen die Reichsten einen grösseren
            Anteil des Gesamtsteuerertrags: Das eine Prozent mit dem höchsten
            Einkommen trägt gemäss den Daten der Eidgenössischen
            Steuerverwaltung für das Jahr 2015 gut 41 Prozent – und nicht 24
            Prozent, wie in der Analyse von Frey und Schaltegger. Dafür ist der
            Beitrag der unteren Hälfte nach neuer Berechnung grösser, nämlich 11
            Prozent statt nur 2.{' '}
          </p>

          <p>
            Diese Unterschiede machen deutlich, dass die Bundessteuer die
            progressivste Einkommenssteuer ist. Das heisst, der Bund finanziert
            sich stärker auf Kosten der Reichsten als Kantone und Gemeinden.
          </p>
          <h3 className='ui small infographic header'>
            Wie wirkt sich ein Prozent mehr Steuern aus?
          </h3>
          <p>
            Nach der auf allen drei Einkommenssteuern basierenden Analyse von
            Frey und Schaltegger versteuern die 500 Top-Verdiener im Schnitt 38
            Prozent des Jahresgehalts, also 4,5 Millionen pro Kopf.
          </p>
          <p>
            Der Staat scheint sie unverhältnismässig zu schröpfen. Vergleicht
            man diese Belastung aber mit jener der nächst tieferen
            Einkommensklasse, gilt es zu relativieren. Diese Steuerzahler
            verdienen nämlich «nur» zwischen 322'636 und 4,3 Millionen Franken
            im Jahr, geben aber mit 32,5 Prozent fast einen gleich grossen
            Anteil an den Staat ab. Ihnen bleibt nach Abzug der Steuern noch
            420'000 Franken im Schnitt, während das durchschnittliche Einkommen
            der Top-Topverdiener nach Steuerabzug immer noch 7,5 Millionen
            Franken beträgt.
          </p>
          <p>
            Ist das gerecht? Wie fielen die Steuererträge aus, wenn die 500
            Bestverdienenden ein Prozent mehr versteuern müssten? Oder die
            unterste Einkommensklasse, 50 Prozent aller Steuerpflichtigen, zwei
            Prozent weniger?
          </p>

          <p>
            Spielen Sie mit unserem Steuerfuss-Kalkulator, und ermitteln Sie,
            welche Auswirkung eine Änderung des Steuersatzes je nach
            Einkommensklasse auf den gesamten Steuerertrag hätte.
          </p>
        </div>
      </div>
      <div className='ui vertical segment'>
        <div className='ui text container'>
          {width < 351 ? <CalculatorS /> : <Calculator />}
        </div>
      </div>

      <Waypoint
        onEnter={event => {
          if (
            event.previousPosition === Waypoint.below &&
            event.currentPosition === Waypoint.inside
          ) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              event: 'Interactions',
              eventAction: 'vertical-scroll',
              eventLabel: '75ContentRead'
            })
          }
        }}
      />

      <main className='ui vertical very fitted segment interview'>
        <div className='ui question container' id='question-2'>
          <h2>
            {/* <span className='title-text'> {this.props.questions[1]}</span> */}
            {/* <Scrollchor to='#nav'>
                <div className='top-link' onClick={this.trackTopClicks}>
                  <div className='arrow-text'>nach oben</div>
                  <i className='chevron up icon' />
                </div>
              </Scrollchor> */}
            Pro & Contra
          </h2>

          <div
            className='ui text container'
            style={{ borderBottom: '1px solid #353535', paddingBottom: '3em' }}
          >
            <Profile
              avatarSrc={require('../../images/funincello.jpg')}
              name=''
              byline=''
            >
              «Das Gesamtsystem ist nämlich nur leicht progressiv.»
              <div className='subquote'>
                Tamara Funiciello &ndash; Präsidentin der Juso, Vizepräsidentin
                SP Schweiz
              </div>
            </Profile>
            <h5>Wie interpretieren Sie diese Zahlen?</h5>
            <p>
              Die Studie betrachtet die progressiven Elemente des Schweizer
              Steuer- und Abgabensystems. Insbesondere die Krankenkassenprämien
              aber werden nicht berücksichtigt und würden ein völlig anderes
              Bild ergeben: Das Gesamtsystem ist nämlich nur leicht progressiv.
              Zudem gibt es viele Einkommensarten wie Aktiengewinne, die sich
              nur Reiche leisten können und die nicht oder nur zum Teil
              besteuert werden. Diese tauchen hier nicht auf.
            </p>
            <h5>
              Warum sind Sie der Meinung, dass die Reichen nicht genug Steuern
              zahlen?
            </h5>
            <p>
              Die Tatsache, dass die Top-Verdiener immer reicher werden, zeigt,
              dass die Steuerlast offensichtlich nicht zu hoch ist. Das reichste
              Prozent besitzt 40 Prozent des Gesamtvermögens. Die 300 Reichsten
              in der Schweiz sind im Jahr 2016 60 Milliarden Franken reicher
              geworden. Ein Grossteil dieser Gelder wird nicht besteuert, weil
              sie eben Kapitalgewinne sind. Gleichzeitig sagt man uns, wir
              könnten uns die AHV nicht mehr leisten, wir bauen bei den
              Prämienverbilligungen ab und bei der Bildung. Das ist nicht die
              Gesellschaft, die wir wollen.
            </p>
            <h5>Was könnte die 99%-Initiative ändern?</h5>
            <p>
              Die 99%-Initiative will Einkommen, für die nicht gearbeitet wurde,
              also etwa Aktiengewinne, ab einem gewissen Betrag stärker
              besteuern als Arbeitseinkommen. Die Mehreinnahmen sollen für
              Sozialwerke oder zur Senkung der Steuern für tiefe und mittlere
              Einkommen eingesetzt werden. Zudem zeigen die Untersuchungen ja
              sogar auf, dass das reichste Prozent im Vergleich zu den reichsten
              10 Prozent schwach besteuert werden. Das möchten wir ändern
              &ndash; darum heisst sie ja auch «99%-Initiative».
            </p>
          </div>
          <div className='ui text container'>
            <Profile
              avatarSrc={require('../../images/portmann.jpg')}
              name=''
              byline=''
            >
              «Je extremer die staatliche Umverteilung ist, desto kleiner wird
              die Gruppe der kräftigen Steuerzahler.»
              <div className='subquote'>
                Hans-Peter Portmann &ndash; FDP-Nationalrat (ZH)
              </div>
            </Profile>

            <h5>Wie interpretieren Sie diese Zahlen?</h5>
            <p>
              Interessant sind diese Zahlen vor allem im Vergleich mit
              wirtschaftsstarken europäischen EU-Ländern. Liegt bei uns in der
              Schweiz der Spitzensteuersatz bei 38 Prozent, liegt dieser in
              Deutschland bereits bei 42 Prozent und geht in anderen EU-Ländern
              bis über 55 Prozent. Man kann feststellen: Je höher diese
              Spitzensätze sind, desto kleiner die Gruppen der höheren
              Einkommensklassen und deren Anteil an der Gesamtsteuerlast. So
              trägt etwa in Deutschland die Gruppe mit den Reineinkommen ab
              100'000 Euro etwas um die 20 Prozent an die
              Einkommenssteuer-Einnahmen bei. In der Schweiz zahlt die
              vergleichbare Steuergruppe stolze 47 Prozent.
            </p>
            <h5>
              Könnten die Reichen nicht noch mehr Steuern zahlen, um die soziale
              Ungleichheit abzufedern?
            </h5>
            <p>
              Je extremer eine staatliche Umverteilung von hohen Einkommen zu
              tiefen Einkommen vorgenommen wird, desto kleiner wird die Gruppe
              der kräftigen Steuerzahler und deren Anteil am
              Gesamtsteueraufkommen. Im Endeffekt führt dies zu noch grösseren
              Ungleichheiten, weshalb bis heute auch noch kein sozialistischer
              Staat überlebt hat, ausser die Staatsfunktionäre haben ihr Volk
              unterdrückt.
            </p>
            <h5>Welche Folgen hätte ein Ja zur 99%-Initiative?</h5>
            <p>
              Wie in allen sozialistisch geführten Ländern würden auch bei uns
              die Leistungsträger mit den höchsten Einkommen sich international
              umorientieren. Damit würden auch die durch ihre Tätigkeiten
              verbundenen Arbeitsplätze in unserem Lande vernichtet. Die
              Steuereinnahmen würden einbrechen, und auf den Mittelstand würde
              eine Mehrbelastung zukommen.
            </p>
          </div>
        </div>
      </main>

      <div className='ui vertical segment purple secondary'>
        <div className='ui text container'>
          <h3 className='ui small infographic header'>Begriffe</h3>
          <p>
            <b>Reineinkommen:</b> Es basiert auf dem steuerbaren Einkommen, also
            der Summe aus Lohn-, Kapital- sowie Renteneinkommen abzüglich der
            Steuerabzüge. Darauf werden gewisse Sozialabzüge wieder aufgerechnet
            (Abzüge für Kinder und unterstützte Personen, der Abzug für
            Versicherungsprämien und Zinsen sowie der Zweitverdienerabzug).
          </p>

          {/* <h3 className='ui small infographic header'>
            Build Timestamp: {window.project.buildTimestamp}
      </h3>
      <div className='ui list'>
        <div className='item'>
          Accessible under <code>window.project.buildTimestamp</code>
        </div>
        <div className='item'>
          Use together with{' '}
          <a href='https://www.npmjs.com/package/@ta-interaktiv/react-publication-info'>
            react-publication-info
          </a>{' '}
          to display the «Updated» timestamp.
        </div>
      </div>
      <h3 className='ui small infographic header'>
          Version: {window.project.version}
      </h3>
      <div className='ui list'>
        <div className='item'>
          Accessible under <code>window.project.version</code>
        </div>
        <div className='item'>
          Taken from package.json. Update the package.json version to bump
          the version number here.
        </div>
      </div> */}
        </div>
      </div>

      {/* TODO Add your credits in this component */}
      <Footer
        articleId={ARTICLE_ID}
        credits={[
          ['Programmierung', 'Sven Cornehls'],
          ['Text und Recherche', 'Simone Luchetta und Edgar Schuler'],
          ['Quelle', 'Universität Luzern']
        ]}
      />
    </div>
  )
}

export default hot(AppComponent)
